/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, safeInvoke } from '@sravni/react-utils';
import { ArrowLeft, ArrowRight } from '@sravni/react-icons';
import '../../Icon/index.js';
import '../../Button/index.js';
import '../../Typography/index.js';
import '../../Space/index.js';
import { getMonthFormatted } from '../utils/date.js';
import modules_75b426be from '../styles/Calendar.module.less.js';
import Space from '../../Space/src/Space.js';
import Button from '../../Button/src/Button.js';
import Icon from '../../Icon/src/Icon.js';
import { Text } from '../../Typography/src/Text.js';

var Header = function (props) {
    var month = props.month, className = props.className, onChange = props.onChange, restProps = __rest(props, ["month", "className", "onChange"]);
    var cx = useStyles(modules_75b426be);
    var classNames = cx(className, 'header');
    var handleChangeMonth = React.useCallback(function (event) {
        safeInvoke(onChange, event.currentTarget.dataset.direction);
    }, [month, onChange]);
    return (React.createElement(Space, __assign({ size: 0, align: "center", justify: "space-between", className: classNames }, restProps),
        React.createElement(Button, { type: "button", color: "blue", variant: "text", "data-direction": "prev", onClick: handleChangeMonth },
            React.createElement(Icon, { strong: true, icon: React.createElement(ArrowLeft, null) })),
        React.createElement(Text, { className: cx('current-month'), capitalize: true }, getMonthFormatted(month)),
        React.createElement(Button, { type: "button", color: "blue", variant: "text", "data-direction": "next", onClick: handleChangeMonth },
            React.createElement(Icon, { strong: true, icon: React.createElement(ArrowRight, null) }))));
};
Header.displayName = 'Header';

export default Header;
//# sourceMappingURL=Header.js.map
